var ProductListLayoutEnum;
(function (ProductListLayoutEnum) {
    ProductListLayoutEnum["grid"] = "grid";
    ProductListLayoutEnum["carousel"] = "carousel";
})(ProductListLayoutEnum || (ProductListLayoutEnum = {}));

var PromotionApplyOnEnum;
(function (PromotionApplyOnEnum) {
    PromotionApplyOnEnum["product"] = "product";
    PromotionApplyOnEnum["partOrder"] = "part-order";
})(PromotionApplyOnEnum || (PromotionApplyOnEnum = {}));

export { ProductListLayoutEnum, PromotionApplyOnEnum };
